import { Button } from "./ui/button";
import { toast } from "sonner";
import { useState } from "react";
import { X, Download, Share2, Trophy, Instagram } from "lucide-react";
import { StoryShareModal } from "./StoryShareModal";
import { inviteUrl } from "../lib/config";

export function ShareWinModal({ username, title, subtitle, tier = "gold", onClose }) {
  const base = process.env.REACT_APP_BACKEND_URL;
  const cardUrl = `${base}/api/og/wincard/${username}.png?title=${encodeURIComponent(title)}&subtitle=${encodeURIComponent(subtitle || "")}&tier=${tier}`;
  const shareUrl = inviteUrl(username);
  const [storyOpen, setStoryOpen] = useState(false);

  const download = async () => {
    try {
      const res = await fetch(cardUrl); const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a"); a.href = url; a.download = `virtustars-win-${username}.png`; a.click(); URL.revokeObjectURL(url);
      toast.success("Win card downloaded");
    } catch { toast.error("Could not download card"); }
  };
  const share = async () => {
    if (navigator.share) { try { await navigator.share({ title, text: `${title} — on VirtuStars`, url: shareUrl }); } catch {} }
    else { navigator.clipboard?.writeText(shareUrl); toast.success("Link copied"); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose} data-testid="share-win-modal">
      <div className="surface rounded-2xl p-6 w-full max-w-md relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 text-muted-foreground hover:text-white"><X size={18} /></button>
        <div className="flex items-center gap-2 mb-1"><Trophy size={18} className="text-gold" /><h3 className="font-display font-bold text-lg">Share your win</h3></div>
        <p className="text-xs text-muted-foreground mb-4">Post this branded card to celebrate and bring fans to VirtuStars.</p>
        <div className="rounded-xl overflow-hidden border border-gold/25 mb-4"><img src={cardUrl} alt="Win card" className="w-full" /></div>
        <Button onClick={() => setStoryOpen(true)} className="w-full rounded-xl btn-blue mb-2" data-testid="win-story-btn"><Instagram size={15} className="mr-1.5" />Share to Instagram Story</Button>
        <div className="grid grid-cols-2 gap-2">
          <Button onClick={download} variant="outline" className="rounded-xl border-white/15" data-testid="win-download-btn"><Download size={15} className="mr-1" />Save</Button>
          <Button onClick={share} className="btn-gold rounded-xl" data-testid="win-share-btn"><Share2 size={15} className="mr-1" />Share</Button>
        </div>
      </div>
      {storyOpen && <StoryShareModal username={username} options={[{ type: "win", label: "Win", title, subtitle, tier }, { type: "profile", label: "Profile" }]} onClose={() => setStoryOpen(false)} />}
    </div>
  );
}
